import { Container, Typography, Box, Divider, Stack } from "@mui/material";
import { useEffect, useState } from "react";
import { GameWithID } from "../../models/Game";
import { ExplorerAPI } from "../../util/Requests";
import { ExplorerEnvironment } from "../../data/Cache";
import GamesSkeleton from "../Elements/GameDisplay/GamesSkeleton";
import PastGame from "../Elements/GameDisplay/PastGame";

// Helper function to check if we need a season divider
const needsSeasonDivider = (
  currentGame: GameWithID,
  previousGame: GameWithID | null
) => {
  if (!previousGame) return false;
  return (
    previousGame.seasonType === "Preseason" &&
    currentGame.seasonType === "Regular Season"
  );
};

// Helper function to get appropriate divider text for game log (chronological order)
const getSeasonDividerText = (
  currentGame: GameWithID,
  previousGame: GameWithID | null
) => {
  if (!needsSeasonDivider(currentGame, previousGame)) return "";

  // For game log, we're going chronologically, so "Regular Season Begins"
  return "Regular Season Begins";
};

export default function GameLog() {
  const [games, setGames] = useState<GameWithID[]>([]);

  useEffect(() => {
    const api = new ExplorerAPI(ExplorerEnvironment.NBA);
    api
      .getGameLog()
      .then((response) => {
        setGames(response.data);
        console.log("game log response: ", response);
      })
      .catch((err) => {
        console.log("error fetching game log: ", err);
      });
  }, []);

  return (
    <Container maxWidth="xl">
      <Typography variant="h2" my={4}>
        Season game log
      </Typography>
      <Stack gap={2}>
        {games.length === 0 ? (
          <GamesSkeleton num={10} />
        ) : (
          games.map((game, index) => {
            const previousGame = index > 0 ? games[index - 1] : null;
            return (
              <Box key={game.id}>
                {needsSeasonDivider(game, previousGame) && (
                  <Box my={3}>
                    <Divider sx={{ mb: 2 }}>
                      <Typography variant="body2" color="text.secondary">
                        {getSeasonDividerText(game, previousGame)}
                      </Typography>
                    </Divider>
                  </Box>
                )}
                <PastGame game={game} />
              </Box>
            );
          })
        )}
      </Stack>
    </Container>
  );
}
